export const PROBABILITY_VALUES = [0.2, 0.4, 0.6, 0.8, 1];
export const DEFAULT_COLORS = [
	'#c5569a',
	'#5b8ad6',
	'#99CC66',
	'#d4b8a3',
	'#ee7023',
];
